import React, { useState, forwardRef } from "react";
import Viewer from "viewerjs/dist/viewer.js";
import { Popout } from "components/popout";

const noImageFallback = "/images/noimage.jpg";

export const ImagePopout = forwardRef(
    (
        {
            photoKey,
            imageUris,
            alt,
            shipmentKey,
            shipmentProductKey,
            isEdited,
            imageSize,
            timeStamp,
            handleOnLoad,
            styleOverrides,
            isInModal,
            srcOverride,
            upc,
            codingWipKey,
            productId,
        },
        imageRef
    ) => {
        let viewer = null;
        const [showPopout, setShowPopout] = useState(false);
        const navToEditedImages = isEdited ? "/edited" : "";
        const size = imageSize || "small";
        const hasTimeStamp = timeStamp ? `?v=${timeStamp}` : "";
        const thumbnailSrc = srcOverride || (imageUris?.[size] ? `${imageUris[size]}${hasTimeStamp}` : noImageFallback);
        const fullSrc = srcOverride || (imageUris?.normal ? `${imageUris.normal}${hasTimeStamp}` : noImageFallback);

        const togglePopout = (bool, e) => {
            if (e && e.ctrlKey) {
                if (!handleImageBrowserUrl()) {
                    return;
                }

                //ctrl+click does not focus on new tab without setTimeout
                return setTimeout(function () {
                    window.open(handleImageBrowserUrl(), "_blank");
                }, 10);
            }

            const useBool = bool ? bool : !showPopout;

            return setShowPopout(useBool);
        };

        const handlePopoutResize = () => {
            if (viewer) {
                viewer.resize();
            }
        };

        const handleImageBrowserUrl = () => {
            if (upc && codingWipKey && productId) {
                return `/image-browser/product-match/${upc}/${codingWipKey}/${productId}`;
            }

            if (shipmentKey && shipmentProductKey) {
                return `/image-browser/${shipmentKey}/${shipmentProductKey}${navToEditedImages}${hasTimeStamp}`;
            }

            return "";
        };

        const onLoad = () => {
            if (viewer) {
                viewer.destroy();
            }

            viewer = new Viewer(document.getElementById(`${photoKey}_hidden-image`), {
                backdrop: false,
                inline: true,
                minWidth: 400,
                minHeight: 400,
                navbar: false,
                button: false,
                title: false,

                toolbar: {
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: false,
                    reset: 1,
                    prev: 0,
                    play: false,
                    next: 0,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
            });
        };

        return (
            <>
                <img
                    ref={imageRef}
                    id={photoKey}
                    src={thumbnailSrc}
                    alt={alt}
                    className="cursor-pointer"
                    onClick={(e) => togglePopout(!showPopout, e)}
                    onLoad={handleOnLoad || null}
                    style={styleOverrides}
                />
                {showPopout && (
                    <Popout
                        id={`${photoKey}_popout`}
                        togglePopout={togglePopout}
                        title="Image Zoom & Rotate"
                        classes="image-popout"
                        isInModal={isInModal}
                        onPopoutResize={handlePopoutResize}
                    >
                        {((shipmentKey && shipmentProductKey) || (upc && codingWipKey && productId)) && (
                            <div className="justify-content-end m-t-10 m-r-20">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="txt-no-decoration txt-bold"
                                    href={handleImageBrowserUrl()}
                                >
                                    Image Browser
                                </a>
                            </div>
                        )}

                        <div
                            className="position-relative image-container"
                            onLoad={onLoad}
                        >
                            <img
                                id={`${photoKey}_hidden-image`}
                                src={fullSrc}
                                className="hide" //workaround for ViewerJS constraints
                                alt={alt}
                            />
                        </div>
                    </Popout>
                )}
            </>
        );
    }
);
